export default __webpack_public_path__ + "static/inae.lee-1ecf2ab02f4b8f2b51531eccc50e0a1d.jpeg";